import { ShippingServiceModelType } from '@teinor/erp/types/company/config/shipping/shippingCompany/shippingService'
import { ConnectedProps, connect } from 'react-redux'
import { useLocation, useParams } from 'react-router'
import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import { GroupVatPayload } from '../../../../../../../utils/reducers/globals/groupVats'
import ModalCreateConfigShippingService from './MCreateCShippingService'
import { TwinTableLink } from '../../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderString, DeleteRow } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import ModalDeleteConfigShippingService from './MDeleteCShippingService'


interface ConfigShippingServicesProps extends ComponentWithPermissions { }

const ConfigShippingServices: React.FC<ConfigShippingServicesProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const pageData = {
        title: t('services', 'Servicios'),
        newText: t('newService', 'Nuevo servicio'),
    }

    return (
        <BaseScreenTable TableComponent={TableConfigShippingServicesConnect} CreateModalComponent={ModalCreateConfigShippingService} DeleteModalComponent={ModalDeleteConfigShippingService} pageData={pageData} userPermissions={userPermissions} />
    )
}

type TableConfigShippingServicesProps = TableComponentProps & ReduxConfigShippingServices & { }

const TableConfigShippingServices: React.FC<TableConfigShippingServicesProps> = ({ setTableInstance, userPermissions, setOpened, groupVats }) => {
    const { t } = useTwinTranslation()
    const { ShippingCompanyId } = useParams()
    const location = useLocation().pathname
    const extraWhereParams = { 'ShippingCompanyId': ShippingCompanyId ? parseInt(ShippingCompanyId) : null, active: true }
    const columns: ColumnTableSchema<ShippingServiceModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
            width: 75
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            minWidth: 130,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'GroupVatId',
            dataKey: 'GroupVatId',
            label: t('groupVatS', 'G. impuestos'),
            minWidth: 105,
            customRender: (parameterValue) => <CustomRenderString value={String(groupVats?.[parameterValue]?.name || '')} />,
            generalSearchable: false
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTableLink columns={columns} createRowDataLink={[location, ['services', '$id']]} name='configShippingServices' extraWhereParams={extraWhereParams} getDataFrom='/api/app/config/shipping/shippingCompany/service/getAllShippingServices' setTableInstance={setTableInstance} hideLoadFiltersButton={true} />
    )

}
const configShippingServicesDispatch = {
    setGroupVats: (payload: GroupVatPayload) => ({ type: 'CHANGE_GROUPVAT', payload }),
}

export type ReduxConfigShippingServices = ConnectedProps<typeof configShippingServicesConnect>
const mapConfigShippingServicesConnector = (state: AllReduxPayloads) => ({ groupVats: state.groupVats })
const configShippingServicesConnect = connect(mapConfigShippingServicesConnector, configShippingServicesDispatch)
const configShippingServicesConnectLoading = withLoading(TableConfigShippingServices, [{ fetchUrl: '/api/app/config/vat/getAllGroupsVat', propName: 'groupVats', setFunctionName: 'setGroupVats' }])
const TableConfigShippingServicesConnect = configShippingServicesConnect(configShippingServicesConnectLoading)

export default ConfigShippingServices